/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingWorkingMicroserviceException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when no working microservice set
 */
let MissingWorkingMicroserviceException = exports.MissingWorkingMicroserviceException = function (_Exception) {
  _inherits(MissingWorkingMicroserviceException, _Exception);

  function MissingWorkingMicroserviceException() {
    _classCallCheck(this, MissingWorkingMicroserviceException);

    return _possibleConstructorReturn(this, (MissingWorkingMicroserviceException.__proto__ || Object.getPrototypeOf(MissingWorkingMicroserviceException)).call(this, 'Missing working microservice from Kernel.MicroserviceInjectable'));
  }

  return MissingWorkingMicroserviceException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Microservice/Exception/MissingWorkingMicroserviceException.js
// module id = 396
// module chunks = 0